import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import { filterInitialValue } from "../util";
import SimpleDate from "../../../../modules/SimpleDate";
import Api from "../../../../Services/Api";
import { fetchDataAsync } from "../../../../Services/Utils";
import { HttpStatus } from "../../../common/Constants";
import { mapToObjectDDL, removeNullFields } from "../../../common/mapper";
import moment from "moment";

class MasterPackageH2Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: filterInitialValue,
      noPeriodData: [
        { label: "YA", value: true },
        { label: "TIDAK", value: false },
      ],
      periodeOption: [
        { value: "START_DATE", label: "Tanggal Mulai" },
        { value: "END_DATE", label: "Tanggal Selesai" },
      ],
      periode: null,
      cabangOptions: [],
    };
  }

  handleSubmit = () => {
    const { onSubmit } = this.props;
    const { filter } = this.state;

    onSubmit(filter);
  };

  handleClear = () => {
    this.setState({
      filter: filterInitialValue,
    });
  };

  handleSetValue = ({ value, name }) => {
    this.setState((prev) => {
      const updatedFilter = {
        ...prev.filter,
        [name]: value,
      };

      if (name === "period") {
        updatedFilter.startDate = null;
        updatedFilter.endDate = null;
      }

      return { filter: updatedFilter };
    });
  };

  componentDidMount() {
    const { submitedFilter } = this.props;
    console.log(submitedFilter);
    
    if (submitedFilter) {
      this.setState({ filter: submitedFilter });
    }
    this.fetchDataCabang();
  }

  fetchDataCabang = async () => {
    this.props.triggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      menuName: "Master Package",
      setError: this.props.setError,
      args: {},
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const filteredData = res?.data?.data?.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item?.kodeCabang)
      );
      this.setState({
        cabangOptions:
          filteredData?.map((item) =>
            mapToObjectDDL(item?.namaDealer, item?.kodeCabang)
          ) || [],
      });
    }
    this.props.triggerLoading();
  };

  render() {
    const { visible, onClickClose } = this.props;
    const { filter, noPeriodData, cabangOptions } = this.state;
    return (
      <React.Fragment>
        <SimpleModal
          title="Filter"
          visible={visible}
          styles={{ width: "50%" }}
          onClickClose={onClickClose}
          content={
            <ModalContainer>
              <FlexView column style={{ gap: "15px" }}>
                <SimpleInput
                  name="packageName"
                  label="Nama Paket"
                  value={filter.packageName}
                  onChange={({ target }) => this.handleSetValue(target)}
                />
                <SimpleDDL
                  label="Cabang Berlaku"
                  id="select_cabang"
                  box="multiselect"
                  name="kodeCabang"
                  options={cabangOptions}
                  value={filter?.kodeCabang}
                  onChange={(value) =>
                    this.handleSetValue({ value, name: "kodeCabang" })
                  }
                />
                {/* <SimpleInput
                  label="Kode Varian"
                  name="kodeVariant"
                  value={filter.kodeVariant}
                  onChange={({ target }) => this.handleSetValue(target)}
                /> */}
                <SimpleDDL
                  label="Kode Varian"
                  id="select_kode_variant"
                  name="kodeVariant"
                  box="search"
                  isClearable
                  options={
                    this.props.dataVariant
                      ? this.props.dataVariant.map((item) => ({
                          label: `${item.kodeVariant} - ${item.namaVariant} `,
                          value: item.kodeVariant,
                          name: item.namaVariant,
                        }))
                      : null
                  }
                  value={filter.kodeVariant}
                  onChange={(value) =>
                    this.handleSetValue({ value, name: "kodeVariant" })
                  }
                />
                <SimpleDDL
                  label="No Period"
                  id="select_has_grace_period"
                  name="hasGracePeriod"
                  box="search"
                  isClearable
                  placeholder="YA / TIDAK"
                  options={noPeriodData}
                  value={filter.hasGracePeriod}
                  onChange={(value) =>
                    this.handleSetValue({ value, name: "hasGracePeriod" })
                  }
                />
                <div
                  className="txt-site txt-11 txt-main txt-bold"
                  style={{ marginTop: 15 }}
                >
                  <h4>Periode</h4>
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "20px" }}
                >
                  <SimpleDDL
                    id="select_options_periode"
                    name="period"
                    box="search"
                    options={this.state.periodeOption}
                    value={filter.period}
                    onChange={(value) =>
                      this.handleSetValue({ value, name: "period" })
                    }
                    styles={{
                      control: (base) => ({
                        ...base,
                        width: 240,
                      }),
                    }}
                  />

                  <SimpleDate
                    id="select_date_start_date"
                    name="startDate"
                    nextdate
                    date={filter.startDate}
                    maxDate={filter.endDate}
                    onChange={(value) =>
                      this.handleSetValue({
                        value: moment(value).format("DD-MM-YYYY"),
                        name: "startDate",
                      })
                    }
                    style={{ width: 150 }}
                    disabled={!filter.period}
                  />

                  <span style={{ marginBottom: 5 }}>s/d</span>

                  <SimpleDate
                    id="select_date_end_date"
                    name="endDate"
                    nextdate
                    date={filter.endDate}
                    onChange={(value) =>
                      this.handleSetValue({
                        value: moment(value).format("DD-MM-YYYY"),
                        name: "endDate",
                      })
                    }
                    style={{ width: 150 }}
                    disabled={!filter.period}
                  />
                </div>
              </FlexView>
              <FlexView style={{ justifyContent: "flex-end" }}>
                <FlexView style={{ gap: "10px" }}>
                  <SimpleButton text="Hapus" onClick={this.handleClear} />
                  <SimpleButton text="Terapkan" onClick={this.handleSubmit} />
                </FlexView>
              </FlexView>
            </ModalContainer>
          }
        />
      </React.Fragment>
    );
  }
}

export default MasterPackageH2Filter;
